import React from 'react';
import '../App.css';
import Headerappprivate from './appPrivate/headerappprivate'
import { Bodyappnegativebalancereportbody} from './bodyappnegativebalancereportbody'
import { Footerappprivate } from './appPrivate/footerappprivate'
import withRouter from './withRouter'
class Bodyappnagativebalancereport extends React.Component {
    constructor(props){
        super(props);
    }
  
  componentDidMount(){
          if(this.props.params.loginToken == '')
          {
              window.location = ('/')
          }

  }

  render(){  
    return (  
      <div className="App">        
        <Headerappprivate/>
        <Bodyappnegativebalancereportbody />
        <Footerappprivate/>
      </div>
    );
  }
}
export default withRouter(Bodyappnagativebalancereport);